// tslint:disable
import { Alerts, AlertSettings } from "../controllers";
import SignIn from "../controllers/signin/signin";
import SignOut from "../controllers/signout/signout";

import reducers from "../reducers/";

import { globalActions } from "../actions";

import * as firebase from "firebase/app";
import "firebase/auth";
import * as React from "react";

import { isAuthenticated, PrivateRoute } from "./private-route/private-route";

import { LoginState } from "../components";

import thunkMiddleware from "redux-thunk";

import { Provider } from "react-redux";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { applyMiddleware, createStore } from "redux";

import "./style.css";

interface IAppProps {
  history?: any;
  location?: any;
}

interface IAppState {
  loginState?: LoginState;
  forceSignout?: boolean;
  maxHeight?: number;
}

const config = {
  apiKey: "AIzaSyAwJYEBGFW2nK_YoWYCpWY80cLgetm28Pc",
  authDomain: "testdata-150e1.firebaseapp.com",
  databaseURL: "https://testdata-150e1.firebaseio.com",
  projectId: "testdata-150e1",
  storageBucket: "testdata-150e1.appspot.com",
  messagingSenderId: "389670297151"
};

firebase.initializeApp(config);

class App extends React.Component<IAppProps, IAppState> {
  public constructor(props: IAppProps) {
    super(props);

    this.state = {
      forceSignout: false,
    };
  }

  public componentDidMount() {
    if (typeof window !== "undefined") {
      const { history } = this.props;

      window.addEventListener("storage", e => {
        if (
          !isAuthenticated("auth") &&
          history.location.pathname !== "/signin"
        ) {
          this.setState({ forceSignout: true });
        }
      });

      window.addEventListener("load",() => {
        // const ios = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
        // if(ios){
        //   const outerDiv = document.getElementById('app-container');
        //   if(outerDiv){
        //     const maxHeight = outerDiv.clientHeight;
        //     this.setState({ maxHeight });
        //   }
        // }
      });
    }
  }

  public render() {
    const store = createStore(reducers, {}, applyMiddleware(thunkMiddleware));
    store.dispatch(globalActions.onUpdateWindowWidth(window.innerWidth));
    store.dispatch(globalActions.onUpdateWindowHeight(window.innerHeight));
    store.dispatch(globalActions.onUpdateDeviceType());
    store.dispatch(globalActions.onGetProfileData());
    window.addEventListener("resize", () => {
      store.dispatch(globalActions.onUpdateWindowWidth(window.innerWidth));
      store.dispatch(globalActions.onUpdateWindowHeight(window.innerHeight));
    });

    const { forceSignout, maxHeight } = this.state;
    return (
      <Provider store={store}>
        <div id="app-container" style={{ height: maxHeight }}>
          <BrowserRouter>
            <Switch>
              <Route
                exact={true}
                path="/"
                render={() => <Redirect to="/signin" />}
              />
              {process.env.REACT_APP_STAGE === "development" ? (
                <Route
                  render={routeProps => (
                    <Alerts routeProps={routeProps} {...this.props as any} />
                  )}
                  path="/alerts"
                />
              ) : (
                <PrivateRoute
                  component={Alerts}
                  path="/alerts"
                  redirectPath="/signin"
                  storageItem="auth"
                />
              )}
              <PrivateRoute
                path="/signout"
                redirectPath="/signin"
                storageItem="auth"
                forceSignout={forceSignout}
                component={SignOut}
              />
              <PrivateRoute
                  component={AlertSettings}
                  path="/alerts-settings"
                  redirectPath="/signin"
                  storageItem="auth"
                />
              <Route
                path="/signin"
                render={routeProps =>
                  isAuthenticated("auth") ? (
                    <Redirect to="/alerts" />
                  ) : (
                    <SignIn routeProps={routeProps} {...this.props as any} />
                  )}
              />
            </Switch>
          </BrowserRouter>
        </div>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App/App.tsx